import { useState, useEffect } from "react";
import { fetchGHLSlots } from "../lib/ghl";

/**
 * Fetches GHL available slots for the next `daysAhead` days.
 * Returns:
 *   slots:   { "2026-05-29": ["09:00", "10:00", ...], ... }
 *   loading: boolean
 *   error:   string | null
 */
export function useGHLSlots(daysAhead = 14) {
  const [slots, setSlots] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const start = new Date();
        start.setHours(0, 0, 0, 0);
        const end = new Date(start);
        end.setDate(start.getDate() + daysAhead);

        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "America/New_York";
        const data = await fetchGHLSlots(start, end, timezone);
        if (!cancelled) setSlots(data);
      } catch (e) {
        if (!cancelled) setError(e.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, [daysAhead]);

  return { slots, loading, error };
}
